import React from 'react'
import List from './list/List'
import Spotlight from './Spotlight'
import Popular from 'scripts/components/content/Popular'
import {isMobile} from 'scripts/lib/utils'
import { Link } from 'react-router-dom'
import locale from 'shared/i18n/react'

const GetPopular = Popular(PopularList)

function PopularFeed() {
  const limit = (!isMobile()) ? 9 : 3
  return (
    <React.Fragment>
      <GetPopular
        title={locale.general.mustRead}
        slug="popular"
        sizeLeft={4}
        sizeRight={8}
        showassoc={true}
        showdate={true}
        page={1}
        limit={limit}
        section="popular" />
      <PopularSeeAll />
    </React.Fragment>
  )
}

function PopularSeeAll() {
  if (isMobile()) {
    return (
      <Link to="/popular" className="btn btn-unicorn btn-block">
        {locale.buttons.seeAll}
      </Link>
    )
  } else {
    return null
  }
}

function PopularList(props) {
  return (
    <List {...props} />
  )
}

const Prefooter = () => {
  return (
    <div className="prefooter-wrapper section">
      <div className="row">
        <div className="col small-12 med-4">
          <PopularFeed />
        </div>
        <div className="col small-12 med-8">
          <Spotlight />
        </div>
      </div>
    </div>
  )
}

export default Prefooter



// WEBPACK FOOTER //
// ./assets/js/components/Prefooter.jsx